import { render } from "./HelpCenter.vue?vue&type=template&id=50e66008&scoped=true"
import script from "./HelpCenter.vue?vue&type=script&lang=js"
export * from "./HelpCenter.vue?vue&type=script&lang=js"

import "./HelpCenter.vue?vue&type=style&index=0&id=50e66008&lang=less&scoped=true"

import exportComponent from "/data/web/antpay-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e66008"]])

export default __exports__